import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { URL_LOGIN, URL_USER_RESERVATIONS, URL_LOGOUT, MOCK_LOGIN, MOCK_STATUS, MOCK_URL_USER_RESERVATION, MOCK_URL_LOGOUT } from '@ibe.config';

import * as fromStore from '../store';
import { INDRAUserData, INDRAUserReservationResponse } from '@ibe.models/user.indra.model.lib';
import { INDRAApiService } from './api.indra.service';

@Injectable({ providedIn: 'root' })
export class INDRAAuthenticationService {
	private URL = './assets/data/user_info.json';
	private httpError: Response = null;

	constructor(
		private http: HttpClient,
		private store: Store<fromStore.State>,
		private api: INDRAApiService
	) { }

	authenticate(credentials: { user: string, password: string }): Observable<any> {

		return this.http.get(this.URL)
			.pipe(
				map((res: Array<any>) => {
					let authUser = null;
					if (credentials) {
						res.forEach(user => {
							if (user.email === credentials.user) {
								authUser = user;
							}
						});
						if (authUser)
							return authUser;
						else
							return res[0];
					}
				}),
				catchError((error: Response) => this.handleError(error))
			);
	}

	public INDRA_login(user: any, pass: any): Observable<INDRAUserData> {
		const data = {
			password: pass,
			username: user
		};
		
		if (MOCK_STATUS.LOGIN) {
			return this.api.INDRA_get<any>(MOCK_LOGIN);
		} else {
			return this.api.INDRA_post<INDRAUserData>(URL_LOGIN, data);
		}
	}
	
	public INDRA_SocialLogin(user: any, type: any): Observable<INDRAUserData> {
		const data = {
			username: user,
			authenticationType: type

		};
		// if (MOCK_STATUS.LOGIN) {
		 // return this.api.INDRA_get<INDRAUserData>(MOCK_LOGIN);
		// } else {
			return this.api.INDRA_post<INDRAUserData>(URL_LOGIN, data);
		// }
	}

	public INDRA_loginCookie(): Observable<INDRAUserData> {
		return this.api.INDRA_post<INDRAUserData>(URL_LOGIN, {});
	}
	
	public INDRA_getUserReservations(tapID: string, frequentFlyerNumber: string) {
		if (MOCK_STATUS.LOGIN) {
			return this.api.INDRA_get<any>(MOCK_URL_USER_RESERVATION);
		} else {
			const data = {
				'tapId': tapID,
				'ffNumber': frequentFlyerNumber
			};
			return this.api.INDRA_post<INDRAUserReservationResponse>(URL_USER_RESERVATIONS, data);
		}
	}
	
	public INDRA_logout() {
		if (MOCK_STATUS.LOGOUT) {
			return this.api.INDRA_get<any>(MOCK_URL_LOGOUT);
		} else {
			return this.api.INDRA_post<any>(URL_LOGOUT, {});
		}
	}

	private handleError(error: Response): any {
		this.httpError = error;
		throw new Error('login error: ' + error.statusText);
	}

}
